import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { ITreeTradeData } from '../../initialState';

export interface IGetTreeTradeRequestAction {
  functions: {
    error: (err: any) => void;
  };
}

function getTreeTradeRequest(
  draft: Draft<ITreeTradeData>,
  _: PayloadAction<IGetTreeTradeRequestAction>,
) {
  draft.getTreeTrade.config.isLoading = true;
}

export default getTreeTradeRequest;
